import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '@/styles/globals.css';

import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Providers } from '@/app/providers';

import { routeTree } from './routeTree.gen';

function DefaultErrorFallback({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div
      style={{
        padding: 32,
        maxWidth: 640,
        margin: '48px auto',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h2 style={{ color: '#ef4444', marginBottom: 12, fontSize: 18 }}>Error inesperado</h2>
      <pre
        style={{
          background: '#1a1a2e',
          color: '#e5e5e5',
          padding: 16,
          borderRadius: 8,
          overflow: 'auto',
          fontSize: 13,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {error.message}
      </pre>
      <button
        type="button"
        onClick={reset}
        style={{
          marginTop: 16,
          padding: '8px 16px',
          borderRadius: 6,
          border: '1px solid #555',
          background: '#2a2a3e',
          color: '#e5e5e5',
          cursor: 'pointer',
          fontSize: 14,
        }}
      >
        Reintentar
      </button>
    </div>
  );
}

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: DefaultErrorFallback,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
